import { NPCDefinition } from '../types/entities';

// Frame mapping for Supreme Court justices in supreme_court_spritesheet
// Each justice has 7 frames in the spritesheet (63 total frames / 9 justices)
const JUSTICE_FRAME_START: Record<string, number> = {
  john_roberts: 1,
  clarence_thomas: 8,
  samuel_alito: 15,
  sonia_sotomayor: 22,
  elena_kagan: 29,
  neil_gorsuch: 36,
  brett_kavanaugh: 43,
  amy_coney_barrett: 50,
  ketanji_brown_jackson: 57,
};

function getJusticeFrame(justiceId: string, offset = 0): string {
  const start = JUSTICE_FRAME_START[justiceId] || 1;
  const frameNum = start + offset;
  return `supreme_court_spritesheet_${String(frameNum).padStart(4, '0')}`;
}

export const NPC_REGISTRY: Record<string, NPCDefinition> = {
  john_roberts: {
    key: "john_roberts",
    atlas: "supreme_court_spritesheet",
    defaultFrame: getJusticeFrame("john_roberts", 0),
    animations: [],
  },
  clarence_thomas: {
    key: "clarence_thomas",
    atlas: "supreme_court_spritesheet",
    defaultFrame: getJusticeFrame("clarence_thomas", 0),
    animations: [],
  },
  samuel_alito: {
    key: "samuel_alito",
    atlas: "supreme_court_spritesheet",
    defaultFrame: getJusticeFrame("samuel_alito", 0),
    animations: [],
  },
  sonia_sotomayor: {
    key: "sonia_sotomayor",
    atlas: "supreme_court_spritesheet",
    defaultFrame: getJusticeFrame("sonia_sotomayor", 0),
    animations: [],
  },
  elena_kagan: {
    key: "elena_kagan",
    atlas: "supreme_court_spritesheet",
    defaultFrame: getJusticeFrame("elena_kagan", 0),
    animations: [],
  },
  neil_gorsuch: {
    key: "neil_gorsuch",
    atlas: "supreme_court_spritesheet",
    defaultFrame: getJusticeFrame("neil_gorsuch", 0),
    animations: [],
  },
  brett_kavanaugh: {
    key: "brett_kavanaugh",
    atlas: "supreme_court_spritesheet",
    defaultFrame: getJusticeFrame("brett_kavanaugh", 0),
    animations: [],
  },
  amy_coney_barrett: {
    key: "amy_coney_barrett",
    atlas: "supreme_court_spritesheet",
    defaultFrame: getJusticeFrame("amy_coney_barrett", 0),
    animations: [],
  },
  ketanji_brown_jackson: {
    key: "ketanji_brown_jackson",
    atlas: "supreme_court_spritesheet",
    defaultFrame: getJusticeFrame("ketanji_brown_jackson", 0),
    animations: [],
  },
};

// Helper to get frame for a specific justice
export { getJusticeFrame, JUSTICE_FRAME_START };
